import { v4 as uuidv4 } from 'uuid'

export class SubscriptionId {
  readonly value: string;
  constructor(value: string) {
    this.value = value;
  }

  toString(): string {
    return this.value;
  }

  static random(): SubscriptionId {
    return new SubscriptionId(uuidv4());
  }
}
